import React, { useState } from "react";
import { Container } from "react-bootstrap";
import { BiEnvelopeOpen } from "react-icons/bi";
import { BsEnvelopeOpen } from "react-icons/bs";
import quickLinks from "../../assets/data/quick-links";
import socialLinks from "../../assets/data/social-links";
import logo from "../../assets/images/logo.png";
import Button from "../Buttons/Button";
import "./Footer.sass";
const Footer = () => {
	const [email, setEmail] = useState("");
	return (
		<footer className="bg--section mt-auto">
			<div className="footer-top">
				<Container>
					<div className="footer-wrapper">
						<div className="footerWidget">
							<a href="/" className="logo">
								<img src={logo} alt="logo" />
							</a>
							<p>
								Afriarts Aims To Enable Economic Participation And
								Cultural Preservation Of African Art And African Artist
								Through Non-Fungible Tokens.
							</p>
						</div>
						<div className="footerWidget newsletterWidget">
							<h5 className="text-gradient">Newsletter</h5>
							<p>
								Be the first one to know about discounts, offers and
								events. Unsubscribe whenever you like.
							</p>
							<form className="subscribeForm">
								<div className="input-group">
									<input
										className="form-control"
										type="text"
										name="email"
										value={email}
										placeholder="Enter Email Address"
										onChange={(e) => setEmail(e.target.value)}
									/>
									<div className="left-icon">
										<BiEnvelopeOpen />
									</div>
									<Button
										text="Submit"
										classes={`btn--base subscribeButton text-dark`}
										type="submit"
									/>
								</div>
							</form>
						</div>
						<div className="footerWidget w-100">
							<div className="footer-contact">
								<div className="contact-info">
									<div className="icon">
										<BsEnvelopeOpen />
									</div>
									<div className="info">
										<span>Contact us at</span>
										<a href="Mailto:info@afriarts.io">
											info@afriarts.io
										</a>
									</div>
								</div>
								<ul className="social-icons">
									{socialLinks
										.map(({ links, icon }, index) => (
											<li key={index}>
												<a href={links}>{icon}</a>
											</li>
										))
										.slice(0, 3)}
								</ul>
							</div>
						</div>
					</div>
				</Container>
			</div>
			<div className="footer-bottom">
				<Container>
					<div className="d-flex flex-wrap justify-content-evenly justify-content-xl-between align-items-center">
						<ul className="quick-links justify-content-center">
							{quickLinks.map(({ link, text }, index) => (
								<li key={index}>
									<a href={link}>{text}</a>
								</li>
							))}
						</ul>
						<div className="copyright">
							&copy; 2000-2021, All Rights Reserved
						</div>
					</div>
				</Container>
			</div>
		</footer>
	);
};

export default Footer;
